import { render, staticRenderFns } from "./MotivoAtendimentoList.vue?vue&type=template&id=79c72a94&scoped=true"
import script from "./MotivoAtendimentoList.vue?vue&type=script&lang=js"
export * from "./MotivoAtendimentoList.vue?vue&type=script&lang=js"
import style0 from "./MotivoAtendimentoList.vue?vue&type=style&index=0&id=79c72a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c72a94",
  null
  
)

export default component.exports